import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import authModule from "./modules/authModule";
import shModule from "./modules/shModule";
import wizardModule from "./modules/wiz/wizardModule";

export default new Vuex.Store({
  state: {
    message: {
      title: "",
      text: "",
      isError: false,
    },
  },
  mutations: {
    updateMessage(state, msg) {
      state.message = msg;
    },
  },
  actions: {
    clearMessage(context) {
      context.commit("updateMessage", { title: "", text: "", type: "" });
    },
  },
  modules: {
    authModule,
    shModule,
    wizardModule,
  },
  getters: {
    url() {
      return process.env.NODE_ENV == "development"
        ? ""
        : "";
    },
    message(state) {
      return state.message;
    },
  },
});
